import { gql } from 'apollo-angular';

/** Admin vehicle-registry batch import (upload preview is REST; see FleetRegistryBatchService). */

const FLEET_REGISTRY_BATCH_FIELDS = `
  fleetRegistryBatchId
  fleetId
  fileName
  status
  totalRows
  successRows
  failedRows
  failureReason
  adminName
  dateStarted
  dateCompleted
  dateCreated
  dateUpdated
`;

export const ADMIN_SUBMIT_FLEET_REGISTRY_BATCH = gql`
  mutation AdminSubmitFleetRegistryBatch($input: AdminSubmitFleetRegistryBatchInput!) {
    adminSubmitFleetRegistryBatch(input: $input) {
      ${FLEET_REGISTRY_BATCH_FIELDS}
    }
  }
`;

export const ADMIN_FLEET_REGISTRY_BATCHES = gql`
  query AdminFleetRegistryBatches($input: AdminFleetRegistryBatchListInput!) {
    adminFleetRegistryBatches(input: $input) {
      total
      page
      limit
      totalPages
      items {
        ${FLEET_REGISTRY_BATCH_FIELDS}
      }
    }
  }
`;

export const ADMIN_FLEET_REGISTRY_BATCH_ROWS = gql`
  query AdminFleetRegistryBatchRows($input: AdminFleetRegistryBatchRowListInput!) {
    adminFleetRegistryBatchRows(input: $input) {
      total
      page
      limit
      totalPages
      items {
        fleetRegistryBatchRowId
        rowNumber
        plateNumber
        conductionNumber
        vehicleMaker
        vehicleModel
        yearModel
        vehicleType
        vehicleId
        driverFirstName
        driverLastName
        driverMobile
        status
        failureReason
        fleetVehicleRegistryId
        dateUpdated
      }
    }
  }
`;
